export const findInboxExpiryTime = message => {
  const {
    inboxExpiry,
    expires,
    assignedExpertExpiry
  } = message;
  try {
    if (assignedExpertExpiry) {
      if (inboxExpiry && inboxExpiry < assignedExpertExpiry && new Date(inboxExpiry) > new Date()) {
        return inboxExpiry;
      }
      if (expires && assignedExpertExpiry < expires) {
        return assignedExpertExpiry;
      }
    }
    let expiryTime;
    if (inboxExpiry !== null && new Date(inboxExpiry) > new Date() && inboxExpiry < expires) {
      expiryTime = inboxExpiry;
    } else {
      expiryTime = expires;
    }
    return expiryTime;
  } catch {
    return expires;
  }
};